import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=5df6d8e3&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df6d8e3')) {
      api.createRecord('5df6d8e3', component.options)
    } else {
      api.reload('5df6d8e3', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=5df6d8e3&", function () {
      api.rerender('5df6d8e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NT4PYv3D7b24/JS/comp/ImgFallback2.vue"
export default component.exports